import { style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';

/**
 * The help beside the value-source select. Pluma's popover grows to the
 * viewport, so a long help would read as one line across the page; this caps
 * it at the width of a Pluma tooltip, as the rows' other hover help is.
 */
export const help = style({ maxWidth: themeVars.space['3200'] }, 'value-source-help');
